<template>
  <v-container>
    <v-card class="masterCard">
      <v-card-title>
        <v-col>
          <v-autocomplete
            class="identification-answer"
            :items="courtDrop"
            label="Corte"
            v-model="courtFilter"
          ></v-autocomplete>
          <v-row>
            <v-autocomplete
              class="identification-answer"
              :items="domainDrop"
              label="Dominio"
              @change="updateSubdomain"
              v-model="domainFilter"
              style="margin-left: 1%; width: 20%"
            ></v-autocomplete>

            <v-autocomplete
              class="identification-answer"
              :items="subdomainDrop"
              label="Sub-dominio"
              style="margin-left: 1%; width: 20%"
              v-model="subdomainFilter"
            ></v-autocomplete>

            <v-autocomplete
              class="identification-answer"
              :items="sectorDrop"
              label="Sector"
              style="margin-left: 1%; width: 20%"
              v-model="sectorFilter"
            ></v-autocomplete>

            <v-autocomplete
              :items="organizationsList"
              v-model="orgSelected"
              label="Institución"
              style="margin-left: 1%; width: 20%"
              @change="filterOrganizations"
            ></v-autocomplete>
          </v-row>
        </v-col>
      </v-card-title>

      <Reports :forms="filteredItems" />
    </v-card>
  </v-container>
</template>

<script>
import Reports from "@/components/reportsTable.vue";
import {
  getEveryForm,
  getAuxiliarByType,
  getCourts,
  getAuxiliarByTypeWithDependency,
} from "@/utils/apiRequest.js";
import { getAnswer } from "@/utils/utils";
export default {
  data() {
    return {
      AuxList: [],
      AuxTypes: [],
      forms: [],
      filteredForms: [],

      organizationsList: [""],
      orgSelected: "",

      selectedAux: [],
      questions: [],
      statusMap: new Map(),

      domainDrop: [""],
      courtDrop: [""],
      subdomainDrop: [""],
      sectorDrop: [""],
      courts: [],

      domainFilter: "",
      sectorFilter: "",
      subdomainFilter: "",
      courtFilter: "",
    };
  },
  components: {
    Reports,
  },
  computed: {
    filteredItems() {
      return this.filteredForms.filter((item) => {
        let courtName = "";
        let court = item.court;
        if (court != undefined) {
          courtName = court.name;
        }

        item.fullText =
          item.name +
          item.id.toString() + // this could be a number, and if name is null, the whole text will be a num
          item.organization +
          item.domain +
          item.subdomain +
          courtName +
          item.sector;

        item.fullText = item.fullText.toLowerCase();

        let included =
          item.fullText.indexOf(this.domainFilter.toLowerCase()) > -1 &&
          item.fullText.indexOf(this.subdomainFilter.toLowerCase()) > -1 &&
          item.fullText.indexOf(this.sectorFilter.toLowerCase()) > -1 &&
          item.fullText.indexOf(this.courtFilter.toLowerCase()) > -1;
        return included;
      });
    },
  },
  methods: {
    updateSelections() {
      let tempTypes = [];
      this.Auxiliares.forEach((aux) => {
        if (aux.type == this.AuxType) {
          tempTypes.push(aux);
        }
      });
      this.selectedAux = tempTypes;
    },

    filterOrganizations(value) {
      this.filteredForms = this.forms;
      this.filteredForms = this.filteredForms.filter((form) => {
        return form.org === value;
      });
    },
    async updateSubdomain(val) {
      let response = await getAuxiliarByTypeWithDependency(
        "Subdominio de la actividad estadística",
        val
      );
      if (response.data.status == "success") {
        let subdomains = [""];
        response.data.auxiliar.forEach((aux) => {
          subdomains.push(aux.value);
        });
        this.subdomainDrop = subdomains;
      }
    },
  },
  async mounted() {
    this.statusMap.set("summited", "digitado sin validar");
    this.statusMap.set("approved", "digitado validado");
    this.statusMap.set("published", "validado para publicación");
    this.statusMap.set("rejected", "rechazado");

    this.statusMap.set("digitado sin validar", "summited");
    this.statusMap.set("digitado validado", "approved");
    this.statusMap.set("validado para publicación", "published");
    this.statusMap.set("rechazado", "rejected");
    let response = await getEveryForm();
    if (response.data.status == "success") {
      this.forms = response.data.forms;
      this.forms.forEach((form) => {
        form.domain = getAnswer(form, "Dominio actividad estadística");
        form.subdomain = getAnswer(
          form,
          "Subdominio de la actividad estadística"
        );
        form.goal = getAnswer(form, "¿Cuál es el objetivo del R.A?");
        form.observationUnit = getAnswer(
          form,
          "¿Cuál(es) es (son) la (s) unidad (es) de observación del R.A?"
        );
        form.name = getAnswer(form, "Nombre del Registro Administrativo");
        form.sector = getAnswer(form, "sector");
        form.org = getAnswer(
          form,
          "Nombre de la institución responsable del R.A"
        );
        form.subdomain = getAnswer(
          form,
          "Subdominio de la actividad estadística"
        );
        let date = new Date(form.updateDate);
        form.updateDate = date.toLocaleString();

        date = new Date(form.date);
        form.date = date.toLocaleString();
        form.status = this.statusMap.get(form.status);
      });

      this.filteredForms = this.forms;
      this.loading = false;
    }

    response = await getAuxiliarByType(
      "Nombre de la institución responsable del R.A"
    );
    if (response.data) {
      if (response.data.status == "success") {
        response.data.auxiliar.forEach((aux) => {
          this.organizationsList.push(aux.value);
        });
      }
    }

    response = await getAuxiliarByType("Dominio actividad estadística");
    if (response.data) {
      if (response.data.status == "success") {
        response.data.auxiliar.forEach((aux) => {
          this.domainDrop.push(aux.value);
        });
      }
    }
    response = await getAuxiliarByType(
      "Subdominio de la actividad estadística"
    );
    if (response.data) {
      if (response.data.status == "success") {
        response.data.auxiliar.forEach((aux) => {
          this.subdomainDrop.push(aux.value);
        });
      }
    }
    response = await getAuxiliarByType("sector");
    if (response.data) {
      if (response.data.status == "success") {
        response.data.auxiliar.forEach((aux) => {
          this.sectorDrop.push(aux.value);
        });
      }
    }

    this.organizationsList = this.organizationsList.sort();
    this.domainDrop = this.domainDrop.sort();
    this.subdomainDrop = this.subdomainDrop.sort();
    this.sectorDrop = this.sectorDrop.sort();

    response = await getCourts();

    if (response.data.status == "success") {
      this.courtFilter = response.data.cortes[0].name
      response.data.cortes.forEach((court) => {
        this.courtDrop.push(court.name);
      });
    }
  },
};
</script>

<style scoped>
.flex {
  align-items: center;
  align-content: center;
  align-self: center;
}
.masterCard {
  align-self: center;
}
</style>